import React from "react";

const NEW = "__new__";
const inputCls = "w-full px-3 py-2 text-sm rounded-md border outline-none";
const inputStyle = { borderColor: "var(--border)", background: "#fff" };

export const SquadraPicker = ({ squadre, value, onChange, testPrefix = "u-squadra" }) => {
  const isNew = value.squadra_id === NEW;
  return (
    <div className="space-y-2" data-testid={`${testPrefix}-picker`}>
      <label className="text-[11px] font-semibold uppercase tracking-wider" style={{ color: "var(--text-muted)" }}>
        Squadra di cui sarà responsabile / supervisore *
      </label>
      <select required data-testid={`${testPrefix}-select`} value={value.squadra_id}
        onChange={(e) => onChange({ squadra_id: e.target.value, nuova_squadra_nome: "" })}
        className={inputCls} style={inputStyle}>
        <option value="">— Seleziona squadra —</option>
        {squadre.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
        <option value={NEW}>+ Crea nuova squadra…</option>
      </select>
      {isNew && (
        <input required autoFocus data-testid={`${testPrefix}-new-name`} placeholder="Nome nuova squadra"
          value={value.nuova_squadra_nome} onChange={(e) => onChange({ ...value, nuova_squadra_nome: e.target.value })}
          className={inputCls} style={inputStyle} />
      )}
    </div>
  );
};

export const squadraPayload = (v) => (v.squadra_id === NEW
  ? { squadra_id: "", nuova_squadra_nome: v.nuova_squadra_nome.trim() }
  : { squadra_id: v.squadra_id, nuova_squadra_nome: "" });
